import { Component, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { ClientService } from '../../../services/client.service';
import { Message, MessageService } from '@rubii/frontend-common';
import { Dsps } from '@rubii/share/src/constants';

@Component({
  selector: 'app-google-sso',
  templateUrl: './google-sso.component.html',
  styleUrls: ['./google-sso.component.scss']
})
export class GoogleSsoComponent extends BaseDatasourceComponent implements OnInit {

  currentStep = 1;
  isValidating = false;
  isDomainValid = false;
  domainErrorMessage = '';
  domain = '';

  private domainPrefixPattern = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/;

  constructor(
    private client: ClientService,
    private snackBar: MatSnackBar,
    private message: MessageService<any>,
    private dialogRef: MatDialogRef<DatasourceConnectionComponent>
  ) {
    super();
  }

  ngOnInit(): void {
    this.connectionForm = new FormGroup({
      domainPrefix: new FormControl('', [Validators.required]),
      emailDomain: new FormControl('', [Validators.required]),
    });
    if (window.location.href.toLowerCase().includes('test.rubiiaws.io')) {
      this.domain = 'test.rubiiaws.io';
    } else if (window.location.href.toLowerCase().includes('rubii.io')) {
      this.domain = 'rubii.io';
    } else if (window.location.href.toLowerCase().includes('nova.rubii.dev')) {
      this.domain = 'nova.rubii.dev';
    } else {
      this.domain = 'localhost';
    }
  }

  validateDomainPrefix(): void {
    const domainPrefixControl = this.connectionForm.get('domainPrefix');
    const value = domainPrefixControl.value?.trim().toLowerCase();

    this.isDomainValid = false;

    if (!value) {
      return;
    }

    if (!this.domainPrefixPattern.test(value)) {
      domainPrefixControl.setErrors({ pattern: true });
      return;
    }

    if (domainPrefixControl.hasError('pattern')) {
      domainPrefixControl.setErrors(null);
    }

    this.isValidating = true;
    this.domainErrorMessage = '';

    this.client.account.isDomainAvailable(value)
      .then(() => {
        this.isValidating = false;
        this.isDomainValid = true;
        domainPrefixControl.setErrors(null);
      })
      .catch((e: Error) => {
        this.isValidating = false;
        this.isDomainValid = false;
        this.domainErrorMessage = e.message || 'This domain is not available';
        domainPrefixControl.setErrors({ unavailable: true });
      });
  }

  goToStep1(): void {
    this.currentStep = 1;
  }

  goToStep2(): void {
    if (this.isDomainValid) {
      this.currentStep = 2;
    }
  }

  connect(): void {
    ['emailDomain'].forEach(field => {
      this.connectionForm.controls[field].markAsDirty();
      this.connectionForm.controls[field].updateValueAndValidity();
    });

    const step2Valid = !this.connectionForm.get('emailDomain').errors;

    if (step2Valid && this.isDomainValid) {
      const payload = {
        shortname: this.connectionForm.get('domainPrefix').value.trim().toLowerCase(),
        emailDomain: this.connectionForm.get('emailDomain').value.trim().toLowerCase(),
      };

      this.client.account.saveGoogleSsoConfig(payload)
        .catch((e: any) => {
          this.openSnackBarWarning(this.snackBar, e.message || 'Failed to save Google SSO configuration', 'closed');
        });

      this.dialogRef.close({ dataSourceId: Dsps.GOOGLE_SSO });
      this.message.signalMessage(new Message('data-source-dialog-closed-' + Dsps.GOOGLE_SSO, { payload, domain: this.domain }));
    }
  }
}
